import _apply from "ramda/src/apply";
import _pluck from "ramda/src/pluck";
import _max from "ramda/src/max";
import _reduce from "ramda/src/reduce";
import _identity from "ramda/src/identity";
import _chain from "ramda/src/chain";
import _pipe from "ramda/src/pipe";
import _applyTo from "ramda/src/applyTo";
import _fromPairs from "ramda/src/fromPairs";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toPairs from "ramda/src/toPairs";
import _curryN from "ramda/src/curryN";
import _head from "ramda/src/head";
import _curry from "ramda/src/curry";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { map as mapIterable } from "../../browser/iterable";
import { isObject } from "../../browser/is";
export var delay = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(ms) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (res) {
            return setTimeout(res, ms);
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function delay(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var toAsync = function toAsync(func) {
  return _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
    var _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", func.apply(void 0, _args2));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
};
export var promisify = function promisify(func) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new Promise(function (resolve, reject) {
      func.apply(void 0, args.concat([function (err, data) {
        err ? reject(err) : resolve(data);
      }]));
    });
  };
};
export var callbackify = function callbackify(func) {
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var cb = args.pop();
    Promise.resolve(args).then(function (args) {
      return func.apply(void 0, _toConsumableArray(args));
    }).then(function (res) {
      return cb(null, res);
    }).catch(function (err) {
      return cb(err);
    });
  };
};
export var reduce = _curry(function () {
  var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(pred, init, iterable) {
    var result, _iterator, _step, el;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          result = init;
          _iterator = _createForOfIteratorHelper(iterable);
          _context3.prev = 2;
          _iterator.s();
        case 4:
          if ((_step = _iterator.n()).done) {
            _context3.next = 11;
            break;
          }
          el = _step.value;
          _context3.next = 8;
          return pred(result, el);
        case 8:
          result = _context3.sent;
        case 9:
          _context3.next = 4;
          break;
        case 11:
          _context3.next = 16;
          break;
        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](2);
          _iterator.e(_context3.t0);
        case 16:
          _context3.prev = 16;
          _iterator.f();
          return _context3.finish(16);
        case 19:
          return _context3.abrupt("return", result);
        case 20:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 13, 16, 19]]);
  }));
  return function (_x2, _x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}());
export var pipe = function pipe() {
  for (var _len3 = arguments.length, funcs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    funcs[_key3] = arguments[_key3];
  }
  return _asyncToGenerator(_regeneratorRuntime.mark(function _callee5() {
    var _len4,
      args,
      _key4,
      _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          for (_len4 = _args5.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = _args5[_key4];
          }
          return _context5.abrupt("return", reduce(function () {
            var _ref5 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee4(args, fn) {
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return fn.apply(void 0, _toConsumableArray(args));
                  case 2:
                    _context4.t0 = _context4.sent;
                    return _context4.abrupt("return", [_context4.t0]);
                  case 4:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            }));
            return function (_x5, _x6) {
              return _ref5.apply(this, arguments);
            };
          }(), args, funcs).then(_head));
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
};
export var pipeC = function pipeC() {
  for (var _len5 = arguments.length, funcs = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    funcs[_key5] = arguments[_key5];
  }
  return _curryN(funcs[0].length)(pipe.apply(void 0, funcs));
};
export var map = _curry(function () {
  var _ref6 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee7(pred, iterable) {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          if (!isObject(iterable)) {
            _context7.next = 3;
            break;
          }
          iterable = _toPairs(iterable);
          return _context7.abrupt("return", Promise.all(mapIterable(function () {
            var _ref8 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee6(_ref7) {
              var _ref9, key, val;
              return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    _ref9 = _slicedToArray(_ref7, 2), key = _ref9[0], val = _ref9[1];
                    _context6.t0 = key;
                    _context6.next = 4;
                    return pred(val);
                  case 4:
                    _context6.t1 = _context6.sent;
                    return _context6.abrupt("return", [_context6.t0, _context6.t1]);
                  case 6:
                  case "end":
                    return _context6.stop();
                }
              }, _callee6);
            }));
            return function (_x9) {
              return _ref8.apply(this, arguments);
            };
          }(), iterable)).then(_fromPairs));
        case 3:
          return _context7.abrupt("return", Promise.all(mapIterable(pred, iterable)));
        case 4:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function (_x7, _x8) {
    return _ref6.apply(this, arguments);
  };
}());
export var mapPairs = _curry(function (pred, obj) {
  return _applyTo(obj, _pipe(_toPairs, map(pred), _fromPairs));
});
export var forEach = _curry(function () {
  var _ref10 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee8(pred, iterable) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return map(pred, iterable);
        case 2:
          return _context8.abrupt("return", iterable);
        case 3:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function (_x10, _x11) {
    return _ref10.apply(this, arguments);
  };
}());
export var filter = _curry(function () {
  var _ref11 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee9(pred, iterable) {
    var bools;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return map(pred, iterable);
        case 2:
          bools = _context9.sent;
          return _context9.abrupt("return", iterable.filter(function (el, i) {
            return bools[i];
          }));
        case 4:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function (_x12, _x13) {
    return _ref11.apply(this, arguments);
  };
}());
export var flatMap = _curry(function () {
  var _ref12 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee10(pred, iterable) {
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.abrupt("return", map(pred, iterable).then(_chain(_identity)));
        case 1:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function (_x14, _x15) {
    return _ref12.apply(this, arguments);
  };
}());
export var mapS = _curry(function () {
  var _ref13 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee12(pred, iterable) {
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          return _context12.abrupt("return", reduce(function () {
            var _ref14 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee11(accum, item) {
              return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) switch (_context11.prev = _context11.next) {
                  case 0:
                    _context11.t0 = [];
                    _context11.t1 = _toConsumableArray(accum);
                    _context11.next = 4;
                    return pred(item);
                  case 4:
                    _context11.t2 = _context11.sent;
                    _context11.t3 = [_context11.t2];
                    return _context11.abrupt("return", _context11.t0.concat.call(_context11.t0, _context11.t1, _context11.t3));
                  case 7:
                  case "end":
                    return _context11.stop();
                }
              }, _callee11);
            }));
            return function (_x18, _x19) {
              return _ref14.apply(this, arguments);
            };
          }(), [], iterable));
        case 1:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function (_x16, _x17) {
    return _ref13.apply(this, arguments);
  };
}());
export var forEachS = _curry(function () {
  var _ref15 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee13(pred, iterable) {
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return mapS(pred, iterable);
        case 2:
          return _context13.abrupt("return", iterable);
        case 3:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return function (_x20, _x21) {
    return _ref15.apply(this, arguments);
  };
}());
export var props = function () {
  var _ref16 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee15(obj) {
    var out;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return map(function () {
            var _ref18 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee14(_ref17) {
              var _ref19, key, promise;
              return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                while (1) switch (_context14.prev = _context14.next) {
                  case 0:
                    _ref19 = _slicedToArray(_ref17, 2), key = _ref19[0], promise = _ref19[1];
                    _context14.t0 = key;
                    _context14.next = 4;
                    return promise;
                  case 4:
                    _context14.t1 = _context14.sent;
                    return _context14.abrupt("return", [_context14.t0, _context14.t1]);
                  case 6:
                  case "end":
                    return _context14.stop();
                }
              }, _callee14);
            }));
            return function (_x23) {
              return _ref18.apply(this, arguments);
            };
          }(), _toPairs(obj));
        case 2:
          out = _context15.sent;
          return _context15.abrupt("return", _fromPairs(out));
        case 4:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return function props(_x22) {
    return _ref16.apply(this, arguments);
  };
}();
export var converge = _curry(function (after, fns) {
  return _curryN(_reduce(_max, 0, _pluck('length', fns)), function () {
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }
    return map(function (fn) {
      return _apply(fn, args);
    }, fns).then(_apply(after));
  });
});
export var tap = _curry(function () {
  var _ref20 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee16(pred, arg) {
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return pred(arg);
        case 2:
          return _context16.abrupt("return", arg);
        case 3:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return function (_x24, _x25) {
    return _ref20.apply(this, arguments);
  };
}());